import { ReactNode } from 'react';

interface NavSectionItemProps {
  // eslint-disable-next-line react/no-unused-prop-types -- TODO: pre-existing, surfaced by removing the NamedMemo wrapper; fix in follow-up
  label: string;
  children: ReactNode;
}
export const NavSectionItem = ({ children }: NavSectionItemProps) => <>{children}</>;
